import * as React from 'react';
import BeatLoader from "react-spinners/BeatLoader";

// Typescript definition
import { jsx as _jsx } from "react/jsx-runtime";
// Loader component with props and its types
const _Loader = props => {
  const {
    loader
  } = props;
  const loaderProps = {
    size: 15,
    margin: 10,
    speed: 1
  };
  return /*#__PURE__*/_jsx(React.Fragment, {
    children: /*#__PURE__*/_jsx(BeatLoader, {
      size: loaderProps.size,
      margin: loaderProps.margin,
      className: "kc-ui-widget-loader",
      loading: loader,
      speedMultiplier: loaderProps.speed
    })
  });
};

// Prop type definition for compile time

// Default props
_Loader.defaultProps = {
  loader: false
};
export const Loader = /*#__PURE__*/React.memo(_Loader);